/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Finnish
export default {
    'fabric.atlassianSwitcher.switchTo': 'Vaihda kohteeseen',
    'fabric.atlassianSwitcher.switchToTooltip': 'Vaihda kohteeseen…',
    'fabric.atlassianSwitcher.recent': 'Viimeaikainen',
    'fabric.atlassianSwitcher.more': 'Lisää',
    'fabric.atlassianSwitcher.try': 'Yritä',
    'fabric.atlassianSwitcher.manageList': 'Hallinnoi luetteloa',
    'fabric.atlassianSwitcher.jiraProject': 'Jira-projekti',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence-työtila',
    'fabric.atlassianSwitcher.people': 'Henkilöt',
    'fabric.atlassianSwitcher.administration': 'Hallinto',
    'fabric.atlassianSwitcher.discoverMore': 'Löydä enemmän',
    'fabric.atlassianSwitcher.errorHeading': 'Jotain meni pieleen',
    'fabric.atlassianSwitcher.errorText': 'Huomioimme nämä virheet, mutta ota meihin yhteyttä, jos sivun lataus ei paranna asiaa',
    'fabric.atlassianSwitcher.errorImageAltText': 'Rikkoutunut robotti ja monta ihmistä korjaamassa sitä.',
    'fabric.atlassianSwitcher.expand': 'Laajenna',
};
//# sourceMappingURL=fi.js.map